import React, { useContext } from 'react';
import { Grid, Paper, Typography, TextField, Button, CircularProgress, Box, useTheme, useMediaQuery } from '@material-ui/core';
import SystemUpdateAltIcon from '@material-ui/icons/SystemUpdateAlt';
import MmsOutlinedIcon from '@material-ui/icons/MmsOutlined';
import ChatMessages from './ChatMessages';
import IconButtonStyled from '../general/IconButtonStyled';
import ButtonStyled from '../general/ButtonStyled';
import "./chat.css";
import AppContext from "../../components/appContext";
import UserList from "./UserList";

const ChatFullView = ({
  users,
  selectedUser,
  handleSelectUser,
  handleViewScreen,
  currentUser,
  groupedMessages,
  filteredMessages,
  loadingMessages,
  newMessage,
  setNewMessage,
  handleKeyDown,
  handleSendMessage,
  showHistory,
}) => {
  const myContext = useContext(AppContext);
  const openSidebar = myContext.openSidebar;


  const theme = useTheme();
  const querysmDown = useMediaQuery(theme.breakpoints.down("sm"));


  const styleBoxContent = {
    width: openSidebar ? "calc(100vw - 260px)" : querysmDown ? "100vw": "calc(100vw - 50px)",
  };

  return (
    <Paper style={styleBoxContent} className="styleBoxContent">
      <Grid container spacing={0}>
        {/* Titres */}
        <Grid item xs={12} container style={{ height: 0 }}>
          <Grid item xs={4}>
            <Typography variant="h6">
              {currentUser?.User?.User_Administrator ? "Bénévoles validés" : "Responsables"}
            </Typography>
          </Grid>
          <Grid item xs={8}>
            <Typography
              variant="h6"
              style={{ display: 'flex', justifyContent: !currentUser?.User?.User_Administrator ? 'flex-end' : 'flex-end' }}
            >
              <Box>
                {showHistory && <ButtonStyled
                  aria-describedby="history-screen"
                  variant="outlined"
                  onClick={() => handleViewScreen('history')}
                  style={{ marginRight: 5 }}
                  iconSize={16}
                  position="left"
                  color='grisBtn'
                >
                  Historique
                  <MmsOutlinedIcon style={{ marginLeft: 15 }} />
                </ButtonStyled>}
                <IconButtonStyled
                  aria-describedby="small-screen"
                  variant="outlined"
                  onClick={() => handleViewScreen('small')}
                  tooltipTitle="Petite vue"
                  style={{ width: 32, height: 32, padding: 5, backgroundColor: 'rgba(0,0,0,0.0)' }}
                  iconSize={16}
                  position="left"
                >
                  <SystemUpdateAltIcon />
                </IconButtonStyled>
              </Box>
            </Typography>
          </Grid>
        </Grid>
        <Grid item xs={4}>
          <UserList
            variant="full"
            users={users}
            selectedUser={selectedUser}
            handleSelectUser={handleSelectUser}
          />
        </Grid>
        <Grid item xs={8} style={{ display: "flex", flexDirection: "column" }}>
          <div style={{ flex: 1 }}>
            {loadingMessages ? (
              <CircularProgress />
            ) : (
              <ChatMessages
                variant="full"
                groupedMessages={groupedMessages}
                filteredMessages={filteredMessages}
                currentUser={currentUser}
              />
            )}
          </div>
          <TextField
            label="Votre message"
            fullWidth
            value={newMessage}
            onChange={(e) => setNewMessage(e.target.value)}
            style={{ marginTop: "1em", marginBottom: "1em" }}
            variant="outlined"
            onKeyDown={handleKeyDown}
          />
          <Button
            variant="contained"
            color="primary"
            onClick={handleSendMessage}
            fullWidth
          >
            Envoyer
          </Button>
        </Grid>
      </Grid>
    </Paper>
  );
};

export default ChatFullView;
